<template>
    <ob1-popin-modal2
        :id="modalId"
        :aria-labelledby="modalLabelId"
        :show-close-button="url != null"
        @ob1-popin-modal-click="closePopin"
    >
        <div :id="modalLabelId" class="h4" v-html="messages.title" />
        <template v-if="url">
            <div v-html="messages.subtitle" />
            <iframe
                id="iframe-id"
                class="mobile-recovery-simulator mt-2"
                :src="url"
                title="simulation de valeur de reprise de mobile"
            />
        </template>
        <recovery-simulator
            v-else
            ref="simulator"
            :shop="shop"
            :messages="messages"
            :modal-id="modalId"
            @update-recovery-simulation="updateRecoveryPrice"
        />
    </ob1-popin-modal2>
</template>

<script>
import RecoverySimulator from "./recoverysimulator/RecoverySimulator.vue";

export default {
    name: "MobileRecoverySimulatorModal",
    components: {RecoverySimulator},
    props: {
        modalId: {
            type: String,
            required: true,
        },
        shop: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: false,
            default: null
        },
        messages: {
            type: Object,
            required: true
        },
    },
    computed: {
        modalLabelId: function () {
            return this.modalId + "-label";
        }
    },
    mounted: function () {
        $(`#${this.modalId}`).on("hidden.bs.modal", () => {
            this.closePopin();
        });
    },
    methods: {
        closePopin() {
            this.$refs.simulator.reset();
            $('#iframe-id').attr('src', this.url);
        },
        updateRecoveryPrice(priceInCents, model) {
            this.$emit('update-recovery-simulation', priceInCents, model);
        }
    }
}
</script>

<style lang="scss">
.mobile-recovery-simulator {
    position: relative;
    display: block;
    border: none;
    height: 80vh;
    width: 100%;
}
</style>
